import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Button, Paper, TextField, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import HomeIcon from '@mui/icons-material/Home'
import { format, startOfMonth } from 'date-fns'

import DownloadAccountChargeRunReportButton from './DownloadAccountChargeRunReportButton'

const API_DATE_FORMAT = 'dd-MMM-yyyy'

const AccountChargeRunPage: React.FC = () => {
  const history = useHistory()
  const [selectedMonth, setSelectedMonth] = useState<Date>(startOfMonth(new Date()))

  const chargeMonth = format(startOfMonth(selectedMonth), API_DATE_FORMAT)

  return (
    <>
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Monthly Account Charge Run</Typography>
        <Button variant={'text'} type='button' onClick={() => { history.push('/app/finance-area') }}>
          <HomeIcon style={{ color: '#444' }} />
        </Button>
      </Box>

      <Paper>
        <Box sx={{ p: 4, maxWidth: 600 }}>
          <Typography variant={'body1'} sx={{ mb: 3 }}>
            The account charge run is scheduled for 6am SAST on the 1st of each month. Choose the month of the
            charge run to export its reports. BTC balances are converted to ZAR at the BTCZAR rate in effect at the
            scheduled run time.
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              views={['year', 'month']}
              label='Charge Run Month'
              value={selectedMonth}
              onChange={(newValue: Date | null) => {
                if (newValue !== null) {
                  setSelectedMonth(startOfMonth(newValue))
                }
              }}
              renderInput={(params: any) => (
                <TextField {...params} sx={{ width: '100%' }} />
              )}
            />
          </LocalizationProvider>

          <Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <DownloadAccountChargeRunReportButton chargeMonth={chargeMonth} reportName={'members'} label={'Export All Members'} />
            <DownloadAccountChargeRunReportButton chargeMonth={chargeMonth} reportName={'charges'} label={'Export Account Charges'} />
          </Box>
        </Box>
      </Paper>
    </>
  )
}

export default AccountChargeRunPage
